<template>
    <div>
        <!--<div style="width: 50%;margin: 20px 0;">
            <span class="searchName" >品名/批次号:</span>
            <el-input
                    size="mini"
                    class="mr10"
                    placeholder="品名或批次号 搜索"
                    v-model="cpinput"
                    clearable>
            </el-input>
            <el-button type="primary" @click="searchData" style="margin-left: 30px" :class="baseerp+'btn'" size="mini">搜索</el-button>
        </div>-->
        <el-table
                size="mini"
                border
                ref="multipleTable"
                :data="detailsData"
                :row-key="getRowKeys"
                height="220"
                tooltip-effect="dark"
                :row-class-name="tableRowClassName"
                @selection-change="handleSelectionChange"
                @select="select"
                @select-all="allchoose"
                style="width: 100%">
            <!--row-key="i_pzid"-->
            <template slot="empty">
                <p>{{dataText}}</p>
            </template>
            <el-table-column
                    align="left"
                    type="selection"
                    :reserve-selection="true"
                    width="55">
            </el-table-column>
            <el-table-column
                    align="center"
                    prop="vc_name"
                    :label="$t('form_product_name')"
                    show-overflow-tooltip>
                <template  slot-scope="scope">
                    <span>{{scope.row.vc_pzname+' '+scope.row.vc_cd+scope.row.vc_gykh+scope.row.vc_bzstyle}}</span>
                </template>
            </el-table-column>
            <!--<el-table-column
                    align="center"
                    prop="vc_no"
                    label="批次号"
                    show-overflow-tooltip>
            </el-table-column>-->
            <el-table-column
                    align="center"
                    prop="f_syglfpnum"
                    :label="$t('invoiceEntry_can_be_associated_with_quantity')"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    align="center"
                    prop="vc_unit"
                    :label="$t('form_unit')"
                    show-overflow-tooltip>
            </el-table-column>
        </el-table>
        <div slot="footer" class="dialog-footer" style="text-align: center;margin-top: 20px">
            <el-button type="primary" @click="saveForm" :class="baseerp+'btn'" size="small" :disabled="disabled">{{$t('button_confirm')}}</el-button>
            <el-button @click="cancel" size="small">{{$t('button_cancel')}}</el-button>
        </div>
    </div>
</template>

<script>
    import * as API from "./api"
    import {baseerp} from "@/utils/baseUrl";
    import Tender from "../../tender/index";
    export default {
        name: "ProductDetails",
        components: {Tender},
        props:{
            productDetails:{
                type:Object,
                required:true,
            }
        },
        data() {
            return {
                getRowKeys(row){
                    return row.i_pzid
                },
                i_htid:0,
                /****************/
                cpinput:"",
                multipleSelection:[],
                detailsData:[],
                /*currentPage:0,
                tableTotal:0,
                pageSize:1,
                pageCount:1,*/
                gsid:0,
                gsid_out:0,
                i_pzid:0,
                ckid:0,
                baseerp:"",
                mid:0,
                dataText:this.$t('tips_data_loading_in_progress'),
                disabled:false,
                selected:[],
                pzids:[],
                i_isfrom:1,
            }
        },
        mounted() {
            this.baseerp=baseerp;
            //console.log(this.productDetails,"productDetails");
            this.i_isfrom=this.productDetails.i_isfrom;
            this.getPzListByHtid();
            //this.mid=this.productDetails.i_mid;
            //this.selected=this.productDetails.selected;
            /*this.ckid=this.productDetails.i_ckid;
            this.gsid_out=this.productDetails.i_gsid_out;
             this.i_pzid=this.productDetails.i_pzid;*/
            //this.getWarehousingProductList();
        },
        methods: {
            //列表
            async getPzListByHtid(){
                let param={
                    //i_type:this.productDetails.i_type,
                    i_id:this.productDetails.i_id,
                    i_khtype:this.productDetails.i_khtype,
                    i_kpkhid: this.productDetails.i_kpkhid,
                    i_gsid:this.productDetails.i_gsid,
                    //f_fpnum:this.productDetails.row.f_fpnum,
                    //vc_fpunit:this.productDetails.row.vc_fpunit,
                    //vc_search: '',
                    //vc_fppzname:this.productDetails.row.vc_fppzname,
                    vc_no:this.productDetails.orderWs,
                    i_isfrom:this.productDetails.i_isfrom,
                };
                let res=await API.pzlist(param);
                if(res.code==1){
                    if (res.data.list.length==0){
                        this.dataText=this.$t('tips_no_data_available_at_the_moment')
                    }
                    this.detailsData=res.data.list;
                    //console.log('this.detailsData',this.detailsData)
                    this.$nextTick(()=>{
                        for(let i=0;i<this.detailsData.length;i++){
                            let pz= this.detailsData[i];
                            for(let s of this.productDetails.selected){
                                if(pz.i_pzid==s.i_pzid){
                                    this.$refs.multipleTable.toggleRowSelection(this.detailsData[i],true)
                                }
                            }
                        }
                    });
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            searchData(){
                this.detailsData=[];
                /*this.pageSize=1;
                this.currentPage=1;*/
                //this.getWarehousingProductList();
            },
            cancel(){
                this.$emit('closePop');
            },
            allchoose(val){
                //console.log(val,'vallllllll')
                if(val.length!=0){
                    let unit = val[0].vc_unit;
                    let some = val.some(item=>{
                        return item.vc_unit!=unit
                    })
                    //console.log('some',some)
                    if(some){
                        let idx = this.tableData.findIndex(item=>(item.vc_no == row.vc_no));
                        this.$refs.table.toggleRowSelection(this.tableData[idx],false)
                        this.$message.error(this.$t('invoiceEntry_the_variety_unit_must_be_consistent'));
                        val.pop();
                    }
                    this.multipleSelection = val;
                    this.pzids = [];
                    this.multipleSelection.map(item=>{
                        this.pzids.push(item);
                    })
                    //console.log(this.multipleSelection)
                    //console.log(this.pzids)
                }else{
                    this.multipleSelection = [];
                    this.pzids = [];
                }

            },
            select(val,row){
                //console.log(val,'vallllllll')
                if(val.length!=0){
                    let unit = val[0].vc_unit;
                    let some = val.some(item=>{
                        return item.vc_unit!=unit
                    })
                    //console.log('some',some)
                    if(some){
                        let idx = this.tableData.findIndex(item=>(item.vc_no == row.vc_no));
                        this.$refs.table.toggleRowSelection(this.tableData[idx],false)
                        this.$message.error(this.$t('invoiceEntry_the_variety_unit_must_be_consistent'));
                        val.pop();
                    }

                    this.multipleSelection = val;
                    this.pzids = [];
                    this.multipleSelection.map(item=>{
                        this.pzids.push(item);
                    })
                    //console.log(this.multipleSelection)
                    //console.log(this.pzids)
                }else{
                    this.multipleSelection = [];
                    this.pzids = [];
                }

            },
            handleSelectionChange:function(val) {
                this.multipleSelection = val;
                //console.log("-------------")
            },
            tableRowClassName({row,rowIndex}){
                //console.log(row.i_gsid,this.gsid)
                /*if(row.i_gsid!=this.gsid){
                    return 'danger-row';
                }*/
                if (row.isother == 1) {
                    return 'danger-row';
                }
            },
            saveForm(){
                //this.disabled=true;
                /*//过滤合同可用量为0
                let choosedata = this.multipleSelection.filter((item)=>{
                    return item.f_num_ky!=0
                })
                this.$emit('transValue',choosedata);*/
                //不控0924
                //单个调用单位转化 多个放走1114
                //全部调convertUnitNew
                if(this.i_isfrom==0||(this.i_isfrom==1&&this.productDetails.row.f_fpnum==0)){
                    let map={
                        fpnum:null,
                        data:this.multipleSelection,
                    }
                    this.$emit('transValue',map,this.productDetails.index,this.productDetails.row);
                    this.$emit('closePop');
                }else{
                    if(this.multipleSelection.length==0){
                        this.$message.error(this.$t('invoiceEntry_please_choose_a_product_name'));
                        return;
                    }else{
                        this.convertUnitNew(this.productDetails.row);
                    }

                }
                /*if(this.multipleSelection.length==1&&this.productDetails.i_isfrom==1){
                    this.productDetails.row.i_pzid=this.multipleSelection[0].i_pzid;
                    this.convertUnitNew(this.productDetails.row);

                }else{
                    this.$emit('transValue',this.multipleSelection,this.productDetails.index,this.productDetails.row);
                    this.$emit('closePop');
                }*/

            },
            // 单位换算
            async convertUnitNew(detail){
                let param={
                    i_mid: this.mid,
                    originDetail:detail,
                    pzids:this.pzids,
                    f_fpnum:this.productDetails.row.f_fpnum,
                    vc_after_unit:this.multipleSelection[0].vc_unit,
                };
                let res=await API.convertUnitNew(param);
                if(res.code==1){
                    res.data.list.map(item=>{
                        item.change=true;
                        //item.pzids=this.pzids;
                        //item.f_syglfpnum=item.f_num;
                    })
                    let map={
                        fpnum:res.data.f_num,
                        data:res.data.list,
                    }
                    this.$emit('transValue',map,this.productDetails.index,this.productDetails.row);
                    this.$emit('closePop');
                }else if (res.code == 0) { //单位换算失败
                    let map={
                        fpnum:null,
                        data:[],
                        pzids:this.pzids,
                    }
                    this.$emit('transValue',map,this.productDetails.index,this.productDetails.row);
                    this.$emit('closePop');
                    this.$message.error(res.message);
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            pageCurrentChange(val){
                this.detailsData=[];
                /*this.pageSize=val;
                this.currentPage=val;*/
                //this.getWarehousingProductList();
            },
        },
    }
</script>

<style lang="scss" scoped>
.searchName{
    width: 100px; display: inline-block;vertical-align: middle;text-align: center;
}
    .mr10{
        width: 50%;
    }

/deep/{
    .danger-row{
        color: #999;
    }
}
</style>